export class FeedbackAllowRequestDto {
    constructor(public learningPackageTranslationId: string,
                public quizTranslationId?: string) {
    }

}
